import { render } from "./NewCopyJob.vue?vue&type=template&id=8a2e9150&scoped=true"
import script from "./NewCopyJob.vue?vue&type=script&lang=js"
export * from "./NewCopyJob.vue?vue&type=script&lang=js"

import "./NewCopyJob.vue?vue&type=style&index=0&id=8a2e9150&scoped=true&lang=css"

import exportComponent from "/tmp/build_3e230bee/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2e9150"]])

export default __exports__